<template>
  <v-navigation-drawer width="400" v-model="localDrawer" right temporary app>
    <!-- Cabeçalho -->
    <v-list-item :class="localAula.color">
      <v-list-item-content>
        <v-list-item-title class="font-weight-medium mb-2 d-flex align-center">
          <span class="flex-grow-1">{{ localAula.tipo_de_aula }}</span>
          <v-btn icon @click="localDrawer = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-list-item-title>
        <!-- <v-list-item-subtitle class="d-flex align-center">
          <v-icon small class="mr-1">mdi-calendar</v-icon>
          <span>{{ localAula.data_formatada }}</span>
        </v-list-item-subtitle> -->
      </v-list-item-content>
    </v-list-item>
    <v-divider></v-divider>

    <v-divider></v-divider>
    <v-list dense>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="font-weight-medium">Professor(a) - INFANTIL</v-list-item-title>
          <v-list-item-subtitle>
            {{ localAula.professor?.nome || "Sem professor" }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <!-- Data -->
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="font-weight-medium">Data</v-list-item-title>
          <v-list-item-subtitle class="d-flex align-center">
            <v-icon small class="mr-1">mdi-calendar</v-icon>
            <span>{{ localAula.data_formatada }}</span>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <!-- Horário -->
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="font-weight-medium">Horários</v-list-item-title>

          <v-list-item-subtitle>
            {{
              localAula.horarios_infantis_com_descricao.length > 0
                ? localAula.horarios_infantis_com_descricao.map((i) => i.descricao).join(", ")
                : "- - -"
            }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        style="margin-top: -32px"
        v-for="(label, key) in $constants.listCamposAulasLancadas"
        :key="key"
      >
        <v-list-item-content
          v-if="key !== 'campos_de_experiencias' && localAula[key] && key !== 'observacoes'"
        >
          <v-list-item-title class="font-weight-medium mt-3">{{ label }}</v-list-item-title>
          <v-list-item-subtitle class="text-justify font-weight-light mt-1">
            <div
              style="padding-bottom: 24px; font-weight: 500"
              v-html="formatTexto(localAula[key])"
            ></div>
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-content
          v-if="key == 'observacoes' && localAula[key]"
          style="margin-top: -26px"
        >
          <v-list-item-title class="font-weight-medium mt-3">{{ label }}</v-list-item-title>
          <v-list-item-subtitle class="text-justify font-weight-light mt-1">
            <div
              style="padding-bottom: 22px; font-weight: 500"
              v-html="formatTexto(localAula[key])"
            ></div>
          </v-list-item-subtitle>
        </v-list-item-content>
        <!-- Campos de Experiências -->
        <div
          style="padding-bottom: 12px; font-weight: 500"
          v-else-if="
            key === 'campos_de_experiencias' && localAula[key] && localAula[key].length > 0
          "
        >
          <v-list-item-title class="font-weight-medium mt-4 mb-2">{{ label }}</v-list-item-title>
          <v-list-item-subtitle>
            <ul v-for="(exp, idx) in localAula[key]" :key="idx" class="mb-1 font-weight-light">
              <li v-if="exp != null" style="font-weight: 500">{{ exp }}</li>
            </ul>
          </v-list-item-subtitle>
        </div>
      </v-list-item>
      <!-- Situação -->
      <v-list-item style="margin-top: -20px">
        <v-list-item-content>
          <v-list-item-title>Situação</v-list-item-title>
          <v-list-item-subtitle>
            <v-chip label :color="localAula.color">
              {{ localAula.descricaoSituacao }}
            </v-chip>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <!-- Motivo -->
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>Motivo</v-list-item-title>
          <v-list-item-subtitle>
            {{ localAula.motivo || "Sem motivo." }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <!-- Atestado (PDF) -->
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>Atestado (PDF)</v-list-item-title>
          <v-list-item-subtitle>
            <a
              v-if="
                localAula.atestado_path &&
                localAula.atestado_path.includes('.pdf') &&
                localAula.option === 'FALTA COM ATESTADO'
              "
              :href="localAula.atestado_path"
              target="_blank"
              >Visualizar</a
            >
            <span v-else>Não existem PDFs anexados.</span>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    aula: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formatarData(aula) {
      if (aula.tipo_de_aula === "Reposição") {
        return `Data original: ${aula.data_formatada} <br /> Data de reposição: ${aula.data_reposicao_formatada}`;
      }
      return `Data: ${aula.data_formatada}`;
    },
    formatTexto(texto) {
      const textoSemColchetes = texto.replace(/\[|\]/g, "");
      const textoSemQuebraDeLinha = textoSemColchetes.replace(/\\n/g, " ").replace(/"/g, "");
      const textoFormatado = textoSemQuebraDeLinha.replace(/\n/g, "<br>");
      return textoFormatado.trim() || "- - -";
    },
  },
  watch: {
    value() {
      this.localDrawer = this.value;
    },
    localDrawer() {
      this.$emit("input", this.localDrawer);
    },
  },
  computed: {
    localAula() {
      return this.aula;
    },
  },
  data() {
    return {
      localDrawer: this.value,
    };
  },
};
</script>

<style lang="scss" scoped>
.v-navigation-drawer {
  background-color: #f8f9fa;
}
.v-list-item {
  &-icon {
    margin-right: 16px;
  }
  &-subtitle {
    font-size: 0.9rem;
  }
}
.v-chip {
  font-size: 0.9rem;
}
.v-card-actions {
  padding: 16px;
}
</style>
